import React from 'react';
import UseWindowDimensions from 'service/hooks/UseWindowDimensions';
import '../../assets/scss/home/drip.scss'
function Drip3(props: any) {
    const { windowHeight, windowWidth } = UseWindowDimensions();


    const preferredWidth = checkIfDevice('preferredWidth');
    const arcWidthPercentage = 0.7; //0-1
    const offsetPer = 0.3; // 0-1
    const containerWidth = windowWidth
    const amount = calAmount(containerWidth, preferredWidth); // needs to be uneven

    const arcWidthArea = Math.round(containerWidth * arcWidthPercentage);
    const dripWidthArea = containerWidth - arcWidthArea;
    const halfOfAmount = (amount - 1) / 2;

    let arcArrayWidth = createUnevenWidth(halfOfAmount + 1, arcWidthArea);
    const height = Math.max(...arcArrayWidth) * 0.8;

    arcArrayWidth = shuffle(arcArrayWidth);
    const arcArrayWidth2 = placeTwoSmallestOnSide(arcArrayWidth);
    let dripArrayWidth = createUnevenWidth(halfOfAmount, dripWidthArea);
    dripArrayWidth = shuffle(dripArrayWidth);
    const dripArrayWidth2 = placeTwoLongestOnSide(dripArrayWidth);
    const widthArray = combineArrays(arcArrayWidth2, dripArrayWidth2);
    const dripArrayHeight = createHeight(halfOfAmount, true);
    const dripArrayHeight2 = placeTwoLongestOnSide(shuffle(dripArrayHeight));
    const arcArrayHeight = createHeight(halfOfAmount + 1, false);
    const arcArrayHeight2 = placeTwoLongestOnSide(shuffle(arcArrayHeight));

    const heightArray = combineArrays(arcArrayHeight2, dripArrayHeight2);

    const mixArrays = (widthArray: number[], heightArray: number[]): number[][] => {
        const accumulator = [];
        for (let i = 0; i < heightArray.length; i++) {
            accumulator.push([widthArray[i], heightArray[i]])
        }
        return accumulator
    }


    let currentXPos = 0;

    const widthHeightArray: number[][] = mixArrays(widthArray, heightArray);

    const drips = widthHeightArray.map((item: number[], index: number) => {
        const singleDripArch = makeDripArc(item[0], item[1], index);
        return singleDripArch;
    })



    return (
        <div className="drip">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${windowWidth} ${windowHeight}`}>
                {drips}
            </svg>
        </div>
    );


    function makeDripArc(_width: number, _height: number, i: number) {
        const dripLow = '1 0 0';
        const dripHigh = '0 0 1';
        let isLow: boolean;
        let arc: String;
        const idNames = ['drip', 'curve'];
        let idType

        if (i % 2 !== 0) {
            isLow = true;
            arc = dripLow;
            idType = idNames[0];
        } else {
            isLow = false;
            arc = dripHigh;
            idType = idNames[1];
        }


        const _halfWidth = Math.floor(_width / 2);

        const path = isLow ? `M ${currentXPos} 0 v ${_height} a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 v -${_height} Z` : `M ${currentXPos -
            1} 0 v ${_height} h 1 a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 h 1 v -${_height} Z`;
        currentXPos += _width;

        return <path fill="red" key={i} className={`${idType}`} id={`${i}`} stroke="none" d={path} />;
    }

    function checkIfDevice(type: any): number {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
                navigator.userAgent
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                navigator.userAgent.substr(0, 4)
            )
        ) {
            if (type === 'preferredWidth') return 50;
            else if (type === 'longAmount') return 2;
            else if (type === 'longLength') return 80;
        } else {
            if (type === 'preferredWidth') return 100;
            else if (type === 'longAmount') return 3;
            else if (type === 'longLength') return 150;
        }
        return 0;
    }

    function placeTwoLongestOnSide(array: Array<number>) {
        let _arr = array;
        const _max1 = Math.max(..._arr);

        _arr.splice(_arr.indexOf(_max1), 1);
        const _max2 = Math.max(..._arr);
        _arr.splice(_arr.indexOf(_max2), 1);
        _arr.push(_max2);
        _arr.unshift(_max1);
        return _arr;
    }
    function placeTwoSmallestOnSide(array: Array<number>) {
        let _arr = array;

        const _min1 = Math.min(..._arr);
        _arr.splice(_arr.indexOf(_min1), 1);
        const _min2 = Math.min(..._arr);
        _arr.splice(_arr.indexOf(_min2), 1);

        _arr.push(_min2);
        _arr.unshift(_min1);

        return _arr;
    }

    function createHeight(_amount: number, _isDrip: boolean) {
        let _array = [];
        if (_isDrip) {
            // if drip
            const longAmount: number = checkIfDevice('longAmount');
            const _dripHeight = checkIfDevice('longLength');
            for (let index = 0; index < _amount; index++) {
                let _random;

                if (index < longAmount) {
                    _random = Math.random() * (height * 0.5) + height * 0.8;
                } else {
                    _random = Math.random() * (height * 0.3);
                }

                const _height = Math.ceil(height + _random);
                _array.push(_height);
            }
        } else {
            // if arc
            for (let index = 0; index < _amount; index++) {
                let _random = Math.random() * (height * 0.3);
                const _height = Math.ceil(height - _random);
                _array.push(_height);
            }
        }
        return _array;
    }

    function calAmount(_containerWidth: number, _preferredWidth: number) {
        let _amount = Math.round(_containerWidth / _preferredWidth);

        if (_amount % 2 === 0) {
            _amount += 1;
        }
        if (_amount < 5) {
            _amount = 5;
        }
        return _amount;
    }

    function combineArrays(uneven: Array<number>, even: Array<number>) {
        let array = [];
        for (let index = 0; index < halfOfAmount; index++) {
            array.push(uneven[index]);
            array.push(even[index]);
        }
        array.push(uneven[halfOfAmount]);
        return array;
    }

    function createUnevenWidth(_amount: number, _widthOfArea: number) {
        const _itemWidth = _widthOfArea / _amount;
        let _arrayOfWidth = [];

        function map_range(value: number, fromLow1: number, fromHigh1: number, toLow2: number, toHigh2: number) {
            return toLow2 + (toHigh2 - toLow2) * (value - fromLow1) / (fromHigh1 - fromLow1);
        }

        for (let i = 0; i < _amount; i++) {
            const _range = map_range(i, 0, _amount - 1, -offsetPer * _itemWidth, offsetPer * _itemWidth);
            _arrayOfWidth.push(Math.round(_itemWidth + _range));
        }
        return _arrayOfWidth;
    }








}
// function makeDripArc2(_width: number, _height: number, i: number) {
//     const dripLow = '1 0 0';
//     const dripHigh = '0 0 1';
//     let isLow: boolean;
//     let arc: String;
//     const idNames = ['drip', 'curve'];

//     if (i % 2 !== 0) {
//         isLow = true;
//         arc = dripLow;
//     } else {
//         isLow = false;
//         arc = dripHigh;
//     }

//     const attributesDripPath = [['id', `${isLow ? idNames[0] : idNames[1]}${i}`], ['fill', 'red']];
//     let _path = setAttributeNSForSvg('path', attributesDripPath);

//     if (isLow === false) {
//         return _path;
//     } else {
//         _path.setAttributeNS(null, 'class', 'point-cursor');
//         const attributesDripAnim = [
//             ['id', `dripAnim${i}`],
//             ['attributeName', 'd'],
//             ['dur', '0.30'],
//             ['type', 'translate'],
//             ['begin', 'indefinite; '],
//             ['repeatCount', '1'],
//             ['calcMode', 'spline'],
//             ['keySplines', '.21,.3,.01,.98'],
//             ['fill', 'remove']
//         ];

//         const _halfWidth = Math.ceil(_width / 2);


//         const path = isLow ? `M ${currentXPos} 0 v ${_height} a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 v -${_height} Z` : `M ${currentXPos -
//             1} 0 v ${_height} h 1 a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 h 1 v -${_height} Z`;




//         return (
//             <path d={`${path}`}
//                 stroke="none"
//                 fill="red" />
//         );
//     }

//     function setAttributeNSForSvg(createElement: string, attributes: string[][], pathElement?: SVGElement) {
//         let _svg = document.createElementNS('http://www.w3.org/2000/svg', createElement);
//         const _halfWidth = Math.ceil(_width / 2);

//         for (let y = 0; y < attributes.length; y++) {
//             _svg.setAttributeNS(null, attributes[y][0], attributes[y][1]);
//         }
//         if (_svg.tagName.toLowerCase() === 'path') {
//             _svg.setAttributeNS(null, 'd', makePath());
//             currentXPos += _width;
//             return _svg;
//         } else {
//             const _copiedPath = getPathFromSvg(pathElement!.getAttributeNS(null, 'd'));
//             _svg.setAttributeNS(null, 'values', `${_copiedPath} ; ${_copiedPath}`);

//             return _svg;
//         }

//         function makePath() {
//             if (isLow) {
//                 return `M ${currentXPos} 0 v ${_height} a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 v -${_height} Z`;
//             } else {
//                 return `M ${currentXPos -
//                     1} 0 v ${_height} h 1 a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 h 1 v -${_height} Z`;
//             }
//         }
//     }
// }



function getPathFromSvg(path: any) {
    const regexPath = /M+ +[0-9]+ +[0-9]+ +v+ +[0-9]+ +a+ +[0-9]+ +[0-9]+ +[0-9]+ +[0-9]+ +[0-9]+ +[0-9]+ +[0-9]+ +v+ +-+[0-9]+ +Z/g;

    let value;
    let values = [];

    while ((value = regexPath.exec(path)) !== null) {
        values.push(value[0]);
    }
    return values;
}


function shuffle(array: any) {
    let currentIndex = array.length,
        randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }

    return array;
}


/////////////////

// function makeDripArc(_width, _height, i) {
//     const dripLow = '1 0 0';
//     const dripHigh = '0 0 1';
//     let isLow;
//     let arc;
//     const idNames = ['drip', 'curve'];

//     if (i % 2 !== 0) {
//         isLow = true;
//         arc = dripLow;
//     } else {
//         isLow = false;
//         arc = dripHigh;
//     }

//     const attributesDripPath = [['id', `${isLow ? idNames[0] : idNames[1]}${i}`], ['fill', 'red']];
//     let _path = setAttributeNSForSvg('path', attributesDripPath);

//     if (isLow === false) {
//         return _path;
//     } else {
//         _path.setAttributeNS(null, 'class', 'point-cursor');
//         const attributesDripAnim = [
//             ['id', `dripAnim${i}`],
//             ['attributeName', 'd'],
//             ['dur', '0.30'],
//             ['type', 'translate'],
//             ['begin', 'indefinite; '],
//             ['repeatCount', '1'],
//             ['calcMode', 'spline'],
//             ['keySplines', '.21,.3,.01,.98'],
//             ['fill', 'remove']
//         ];
//         let _anim = setAttributeNSForSvg('animate', attributesDripAnim, _path);
//         _path.appendChild(_anim);
//         return _path;
//     }

//     function setAttributeNSForSvg(createElement, attributes, pathElement) {
//         let _svg = document.createElementNS('http://www.w3.org/2000/svg', createElement);
//         const _halfWidth = Math.ceil(_width / 2);

//         for (let y = 0; y < attributes.length; y++) {
//             _svg.setAttributeNS(null, attributes[y][0], attributes[y][1]);
//         }
//         if (_svg.tagName.toLowerCase() === 'path') {
//             _svg.setAttributeNS(null, 'd', makePath());
//             currentXPos += _width;
//             return _svg;
//         } else {
//             const _copiedPath = getPathFromSvg(pathElement.getAttributeNS(null, 'd'));
//             _svg.setAttributeNS(null, 'values', `${_copiedPath} ; ${_copiedPath}`);

//             return _svg;
//         }

//         function makePath() {
//             if (isLow) {
//                 return `M ${currentXPos} 0 v ${_height} a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 v -${_height} Z`;
//             } else {
//                 return `M ${currentXPos -
//                     1} 0 v ${_height} h 1 a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 h 1 v -${_height} Z`;
//             }
//         }
//     }
// }


// function makeSVG() {
//     const preferredWidth = checkIfDevice('preferredWidth');
//     const arcWidthPercentage = 0.7; //0-1
//     const offsetPer = 0.3; // 0-1
//     let currentXPos = 0;
//     const containerWidth = windowWidth
//     const containerHeight = window.innerHeight;
//     const amount = calAmount(containerWidth, preferredWidth); // needs to be uneven

//     const arcWidthArea = Math.round(containerWidth * arcWidthPercentage);
//     const dripWidthArea = containerWidth - arcWidthArea;
//     const halfOfAmount = (amount - 1) / 2;
//     // const height = containerWidth / amount;

//     let arcArrayWidth = createUnevenWidth(halfOfAmount + 1, arcWidthArea);
//     const height = Math.max(...arcArrayWidth) * 0.8;

//     arcArrayWidth = shuffle(arcArrayWidth);
//     const arcArrayWidth2 = placeTwoSmallestOnSide(arcArrayWidth);

//     let dripArrayWidth = createUnevenWidth(halfOfAmount, dripWidthArea);
//     dripArrayWidth = shuffle(dripArrayWidth);
//     const dripArrayWidth2 = placeTwoLongestOnSide(dripArrayWidth);

//     const widthArray = combineArrays(arcArrayWidth2, dripArrayWidth2);

//     const dripArrayHeight = createHeight(halfOfAmount, true);

//     // const dripArrayHeight = createUnevenWidth(halfOfAmount, (halfOfAmount + 1) * height);
//     const dripArrayHeight2 = placeTwoLongestOnSide(shuffle(dripArrayHeight));

//     const arcArrayHeight = createHeight(halfOfAmount + 1, false);
//     const arcArrayHeight2 = placeTwoLongestOnSide(shuffle(arcArrayHeight));

//     const heightArray = combineArrays(arcArrayHeight2, dripArrayHeight2);



//     let svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
//     svgElement.setAttributeNS(null, 'viewBox', `0 0 ${containerWidth} ${containerHeight} `);

//     svgElement.setAttributeNS(null, 'id', 'dripperSvg');

//     let group = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
//     group.setAttributeNS(null, 'id', 'groupDripper');
//     group.setAttributeNS(null, 'viewBox', `0 0 ${containerWidth} ${containerHeight} `);
//     ////
//     for (let i = 0; i < amount; i++) {
//         group.appendChild(makeDripArc(widthArray[i], heightArray[i], i));
//     }
//     svgElement.appendChild(group);

//     document.getElementById(htmlDivId).appendChild(svgElement);

//     function makeDripArc(_width, _height, i) {
//         const dripLow = '1 0 0';
//         const dripHigh = '0 0 1';
//         let isLow;
//         let arc;
//         const idNames = ['drip', 'curve'];

//         if (i % 2 !== 0) {
//             isLow = true;
//             arc = dripLow;
//         } else {
//             isLow = false;
//             arc = dripHigh;
//         }

//         const attributesDripPath = [['id', `${isLow ? idNames[0] : idNames[1]}${i}`], ['fill', 'red']];
//         let _path = setAttributeNSForSvg('path', attributesDripPath);

//         if (isLow === false) {
//             return _path;
//         } else {
//             _path.setAttributeNS(null, 'class', 'point-cursor');
//             const attributesDripAnim = [
//                 ['id', `dripAnim${i}`],
//                 ['attributeName', 'd'],
//                 ['dur', '0.30'],
//                 ['type', 'translate'],
//                 ['begin', 'indefinite; '],
//                 ['repeatCount', '1'],
//                 ['calcMode', 'spline'],
//                 ['keySplines', '.21,.3,.01,.98'],
//                 ['fill', 'remove']
//             ];
//             let _anim = setAttributeNSForSvg('animate', attributesDripAnim, _path);
//             _path.appendChild(_anim);
//             return _path;
//         }

//         function setAttributeNSForSvg(createElement, attributes, pathElement) {
//             let _svg = document.createElementNS('http://www.w3.org/2000/svg', createElement);
//             const _halfWidth = Math.ceil(_width / 2);

//             for (let y = 0; y < attributes.length; y++) {
//                 _svg.setAttributeNS(null, attributes[y][0], attributes[y][1]);
//             }
//             if (_svg.tagName.toLowerCase() === 'path') {
//                 _svg.setAttributeNS(null, 'd', makePath());
//                 currentXPos += _width;
//                 return _svg;
//             } else {
//                 const _copiedPath = getPathFromSvg(pathElement.getAttributeNS(null, 'd'));
//                 _svg.setAttributeNS(null, 'values', `${_copiedPath} ; ${_copiedPath}`);

//                 return _svg;
//             }

//             function makePath() {
//                 if (isLow) {
//                     return `M ${currentXPos} 0 v ${_height} a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 v -${_height} Z`;
//                 } else {
//                     return `M ${currentXPos -
//                         1} 0 v ${_height} h 1 a ${_halfWidth} ${_halfWidth} ${arc} ${_width} 0 h 1 v -${_height} Z`;
//                 }
//             }
//         }
//     }
// }


export default Drip3;